import { useEffect } from 'react';

// Set document.title for the lifetime of the calling component, restore
// the previous title on unmount. Safe to call with a falsy `name` — the
// hook becomes a no-op until real data arrives, so it never sets
// "null | Space Explorer" mid-load.
//
// Used by the explorer bot's report_location MCP tool (reads
// document.title via CDP) so the rail card can show "Now at <SPACE>"
// instead of inheriting the root "<title>Space Explorer</title>" from
// public/index.html on every page.
//
// Suffix defaults to "Space Explorer" so browser tabs read
// "Glitch | Space Explorer" — consistent with most product-page title
// conventions (page name | brand).
export default function useDocumentTitle(name, suffix = 'Space Explorer') {
  useEffect(() => {
    if (!name || typeof name !== 'string' || name.trim() === '') return undefined;
    const previous = document.title;
    document.title = `${name.trim()} | ${suffix}`;
    return () => {
      document.title = previous;
    };
  }, [name, suffix]);
}
